import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

interface IProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  children: React.ReactNode;
  title: React.ReactNode;
  fullWidth?: boolean;
}

export default function SimpleModal({
  open,
  setOpen,
  children,
  title,
  fullWidth,
}: IProps) {
  const handleClose = () => setOpen(false);

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      maxWidth="lg"
      fullWidth={fullWidth}
    >
      <Box display="flex" alignItems="center">
        <Box flexGrow={1} sx={{ px: 4, py: 3 }}>
          {title}
        </Box>
      </Box>
      <DialogContent sx={{ px: 4, py: 2 }}>{children}</DialogContent>
      <DialogActions>
        <Box sx={{ alignItems: "flex-end" }}>
          <Button
            data-testid="close-button"
            variant="contained"
            onClick={handleClose}
          >
            Close
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
